export default __webpack_public_path__ + "static/media/attendance_banner1.f1835103.png";